import axiosInstance from '../api/axios';

export interface IResolutionEmbed {
  player: 'aws';
  embedUrl: string;
  embedExpiresAt: string | null;
  videoPlatformId: string;
}

/**
 * URL do Player AWS para a resolução em vídeo de um exercício. É temporária
 * (credencial no fragmento): pedir a cada abertura do player, nunca guardar.
 */
export async function getResolutionEmbed(
  videoPlatformId: string
): Promise<IResolutionEmbed> {
  const response = await axiosInstance.get(
    `/exercises/resolution-video/${encodeURIComponent(videoPlatformId)}/embed`
  );

  return response.data;
}

/**
 * Resolução ligada pelo Vimeo ID: o embed do Player AWS quando esse vídeo já
 * está lá. 404 quando não está (o player toca o Vimeo).
 */
export async function getResolutionEmbedByVimeo(
  vimeoID: string
): Promise<IResolutionEmbed> {
  // Teto de tempo: com o backend ou o Player lento, o Vimeo entra logo.
  const response = await axiosInstance.get(
    `/exercises/resolution-video/vimeo/${encodeURIComponent(vimeoID)}/embed`,
    { timeout: 6000 }
  );

  return response.data;
}

/**
 * Vídeo do tema de redação (a videoaula pelo _id): o embed do Player AWS. 404
 * quando a videoaula fica no Vimeo (o player toca o Vimeo gravado nela).
 */
export async function getEssayThemeVideoEmbed(
  lessonId: string
): Promise<IResolutionEmbed> {
  const response = await axiosInstance.get(
    `/essaythemes/videos/${encodeURIComponent(lessonId)}/embed`,
    { timeout: 6000 }
  );

  return response.data;
}

/**
 * Vídeo de modal ("Como funciona"), pelo Vimeo ID de `constants/modal-videos`:
 * o embed do Player AWS. 404 quando o vídeo não está lá (o player toca o
 * Vimeo).
 */
export async function getModalVideoEmbed(
  vimeoID: string
): Promise<IResolutionEmbed> {
  const response = await axiosInstance.get(
    `/modal-videos/vimeo/${encodeURIComponent(vimeoID)}/embed`,
    { timeout: 6000 }
  );

  return response.data;
}
